import React from 'react'
import {
  useConversationsPerDay,
  useConversationsPerWeek,
} from '../../hooks/analytics/useAnalytics'
import GranularitySwitchChart from './GranularitySwitchChart'

const ConversationsChart: React.FC = () => {
  const conversationsPerWeek = useConversationsPerWeek()
  const conversationsPerDay = useConversationsPerDay()

  return (
    <GranularitySwitchChart
      title='Conversations'
      valueLabel='Conversations'
      daily={{
        isLoading: conversationsPerDay.isLoading,
        isError: conversationsPerDay.isError,
        points: (conversationsPerDay.data ?? []).map(point => ({
          day: point.day,
          value: point.conversations,
        })),
      }}
      weekly={{
        isLoading: conversationsPerWeek.isLoading,
        isError: conversationsPerWeek.isError,
        points: (conversationsPerWeek.data ?? []).map(point => ({
          day: point.week_start,
          value: point.conversations,
        })),
      }}
      dailySubtitle={days =>
        `Conversations started per day (last ${days} days). Today is partial.`
      }
      weeklySubtitle={weeks =>
        `Conversations started per week (last ${weeks} weeks). The current week is partial.`
      }
    />
  )
}

export default ConversationsChart
